import React from 'react';
import RenewDialog from 'components/legacy/RenewDialog';
import ProjectAddDialog from 'pages/projects/ProjectAddDialog';
import DeleteProjectDialog from 'pages/projects/DeleteDialog';
import EditNameDialog from 'pages/projects/EditNameDialog';
import TaskSchedulerDialog from 'components/legacy/TaskSchedulerDialog';
import Dialogs from 'components/legacy/Dialogs';
import GlobalStyles from './GlobalStyles';
import ResetScrollUponNav from './ResetScrollUponNav';

const GlobalComponents = () => {
	return (
		<>
			<GlobalStyles />
			<Dialogs />
			<RenewDialog />
			<ResetScrollUponNav />
			<ProjectAddDialog />
			<DeleteProjectDialog />
			<EditNameDialog />
			<TaskSchedulerDialog />
		</>
	);
};

export default GlobalComponents;
